import { z } from "zod";
// Schema for category translations (embedded in DynamoDB item)
export const CategoryTranslationSchema = z.object({
    name: z.string().min(1),
    description: z.string().nullable().optional(),
});
// Main Category schema for DynamoDB
export const CategorySchema = z.object({
    id: z.number().int(),
    name: z.string().max(255),
    slug: z.string().max(255).optional(),
    description: z.string().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    // Parent relationship (stored directly, not in separate table)
    parent_id: z.number().int().nullable().optional(),
    // Denormalized parent info for quick access
    parent_name: z.string().nullable().optional(),
    parent_slug: z.string().nullable().optional(),
    // Depth in hierarchy (0 = root)
    depth: z.number().int().min(0).optional(),
    // Full path for display (e.g., "Grammar > Verbs > Present Tense")
    path: z.string().optional(),
    // Embedded translations (DynamoDB denormalization)
    translations: z.record(z.string(), CategoryTranslationSchema).optional(),
});
// Category with children hierarchy (for tree building)
export const CategoryHierarchySchema = CategorySchema.extend({
    children: z.lazy(() => CategoryHierarchySchema.array()),
});
// Category with parents hierarchy (for breadcrumb/path building)
export const CategoryHierarchyReverseSchema = CategorySchema.extend({
    parents: z.lazy(() => CategoryHierarchyReverseSchema.array()),
});
// Category with both children and parents (full context)
export const CategoryHierarchyCombinedSchema = CategorySchema.extend({
    children: z.lazy(() => CategoryHierarchySchema.array()),
    parents: z.lazy(() => CategoryHierarchyReverseSchema.array()),
});
// Schema for creating/updating categories
export const CategoryPayloadSchema = z.object({
    id: z.number().int().optional(),
    name: z.string().max(255),
    slug: z.string().max(255).optional(),
    description: z.string().nullable().optional(),
    parent_id: z.number().int().nullable().optional(),
    translations: z.record(z.string(), CategoryTranslationSchema).optional(),
});
// Simple category for batch import
export const SimpleCategorySchema = z.object({
    name: z.string(),
    description: z.string().nullable().optional(),
    translations: z
        .record(z.string(), z.object({
        name: z.string(),
        description: z.string().nullable().optional(),
    }))
        .optional(),
});
// Category path for batch import (array of simple categories from root to leaf)
export const CategoryPathSchema = z.array(SimpleCategorySchema);
